(function() {
  var __cyA=Date.UTC(2026,4,29,13,0,0),__cyB=Date.UTC(2026,5,4,3,59,59);
  if(location.search.indexOf('cyber=preview')!==-1||(Date.now()>=__cyA&&Date.now()<=__cyB))return; // Cyber: usa free-gift-tote.js (opt-in)
  var TOTE_VARIANT = 52855884972348;
  var TOTE_FREE_VARIANT = 52915410174268;
  var TOTE_IMG = "https://cdn.shopify.com/s/files/1/0793/5315/1804/t/3/assets/tote-bag-nobg.png?v=1773338517";
  var FREE_THRESHOLD = 10000000;

  function formatCLP(amount) {
    var pesos = Math.round(amount / 100);
    return '$' + pesos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function isToteVariant(id) {
    return id === TOTE_VARIANT || id === TOTE_FREE_VARIANT;
  }

  function getTierInfo() {
    var info = { isMuseFirst: false, isHc: false, isGuest: true };
    // Read from tote-upsell elements first
    document.querySelectorAll(".tote-upsell").forEach(function(c) {
      if (c.dataset.isMuseFirst === "true") info.isMuseFirst = true;
      if (c.dataset.isHc === "true") info.isHc = true;
      if (c.dataset.isGuest === "false") info.isGuest = false;
    });
    // Fallback: read from body data attributes (always available)
    var body = document.body;
    if (body.dataset.customerLoggedIn === "true") {
      info.isGuest = false;
      var orders = parseInt(body.dataset.customerOrders) || 0;
      var tier = body.dataset.customerTier || "";
      if (tier.indexOf("loyalty-muse") !== -1 && orders === 0) info.isMuseFirst = true;
      if (tier.indexOf("loyalty-hautecouture") !== -1) info.isHc = true;
    }
    return info;
  }

  function getVariantForAdd(container) {
    if (!container) return TOTE_VARIANT;
    var m = container.dataset.isMuseFirst === "true";
    var h = container.dataset.isHc === "true";
    if (m || h) return TOTE_FREE_VARIANT;
    var ct = parseInt(container.dataset.cartTotal) || 0;
    if (ct >= FREE_THRESHOLD) return TOTE_FREE_VARIANT;
    return TOTE_VARIANT;
  }

  /* ── Event handlers ── */
  document.addEventListener("change", function(e) {
    if (!e.target.classList.contains("tote-upsell-checkbox")) return;
    var cb = e.target;
    var container = cb.closest(".tote-upsell");
    cb.disabled = true;
    if (cb.checked) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({items: [{id: getVariantForAdd(container), quantity: 1}]})
      }).then(function() { reloadCart(); })
        .catch(function() { cb.checked = false; cb.disabled = false; });
    } else {
      var key = container ? container.dataset.toteKey : "";
      fetch("/cart/change.js", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({id: key, quantity: 0})
      }).then(function() { reloadCart(); })
        .catch(function() { cb.checked = true; cb.disabled = false; });
    }
  });

  document.addEventListener("click", function(e) {
    var btn = e.target.closest(".tote-upsell-add-free");
    if (!btn) return;
    btn.disabled = true;
    btn.textContent = "Agregando...";
    var container = btn.closest(".tote-upsell");
    fetch("/cart/add.js", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({items: [{id: getVariantForAdd(container), quantity: 1}]})
    }).then(function() { reloadCart(); });
  });

  /* ── Cart reload ── */
  function reloadCart() {
    if (window.location.pathname === "/cart") {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
    fetch("/cart.js").then(function(r){return r.json()}).then(function(cart){
      document.querySelectorAll(".js-cart-count, .cart-link__count").forEach(function(el){ el.textContent = cart.item_count; });
      updateDrawerUpsell(cart);
    });
  }

  /* ── Cart drawer dynamic update ── */
  function updateDrawerUpsell(cart) {
    document.querySelectorAll(".tote-upsell:not(.tote-upsell--product)").forEach(function(c) {
      var tier = getTierInfo();
      if (tier.isMuseFirst || tier.isHc || tier.isGuest) return;

      var totalExTote = cart.total_price;
      var toteInCart = false;
      cart.items.forEach(function(item) {
        if (isToteVariant(item.variant_id)) { toteInCart = true; totalExTote -= item.final_line_price; }
      });

      var isFree = totalExTote >= FREE_THRESHOLD;
      if (isFree && !toteInCart) {
        c.innerHTML = '<label style="display:flex;align-items:center;cursor:pointer;margin:0;">'
          + '<input type="checkbox" class="tote-upsell-checkbox" style="min-width:16px;min-height:16px;accent-color:#1a1a1a;cursor:pointer;margin-right:8px;">'
          + '<span style="font-size:12px;color:#1a1a1a;">Agrega tu <strong>Tote Bag GRATIS</strong></span>'
          + '<img src="' + TOTE_IMG + '" alt="Tote Bag" width="28" height="45" style="object-fit:contain;margin-left:6px;">'
          + '</label>';
        subtleHighlight(c);
      }
    });
  }

  /* ── Subtle highlight animation ── */
  function subtleHighlight(el) {
    el.style.transition = 'background 0.6s ease, box-shadow 0.6s ease';
    el.style.background = '#faf5ed';
    el.style.borderRadius = '6px';
    el.style.padding = '8px 10px';
    el.style.boxShadow = '0 0 0 1px #e8dcc8';
    setTimeout(function() {
      el.style.background = 'transparent';
      el.style.boxShadow = 'none';
      el.style.padding = '6px 0';
    }, 3000);
  }

  /* ── Product page upsell ── */
  function initProductUpsell() {
    var buyBtns = document.querySelector("buy-buttons");
    if (!buyBtns || document.querySelector(".tote-upsell--product")) return;

    fetch("/cart.js")
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var toteInCart = false, totalExTote = cart.total_price, toteKey = "";
        cart.items.forEach(function(item) {
          if (isToteVariant(item.variant_id)) {
            toteInCart = true;
            totalExTote -= item.final_line_price;
            toteKey = item.key;
          }
        });

        var tier = getTierInfo();
        var freeByTier = tier.isMuseFirst || tier.isHc;
        var freeByAmount = totalExTote >= FREE_THRESHOLD;
        var remaining = FREE_THRESHOLD - totalExTote;
        var pct = Math.min(100, Math.round((totalExTote / FREE_THRESHOLD) * 100));

        var wrap = ' style="display:flex;align-items:center;gap:12px;padding:12px 14px;margin:0 0 12px;border:1px solid #e8e3dc;border-radius:6px;background:#faf8f5;"';
        var html = '<div class="tote-upsell tote-upsell--product"'
          + ' data-tote-variant="' + TOTE_VARIANT + '"'
          + ' data-tote-free-variant="' + TOTE_FREE_VARIANT + '"'
          + ' data-tote-key="' + toteKey + '"'
          + ' data-is-muse-first="' + tier.isMuseFirst + '"'
          + ' data-is-hc="' + tier.isHc + '"'
          + wrap + '>';
        html += '<img src="' + TOTE_IMG + '" alt="Tote Bag Ochi & Co" width="45" height="72" style="object-fit:contain;flex-shrink:0;">';

        if (toteInCart) {
          /* Already in cart */
          if (freeByTier || freeByAmount) {
            var r = tier.isMuseFirst ? "Regalo de bienvenida" : (tier.isHc ? "Exclusivo Haute Couture" : "Incluida sobre $100.000");
            html += '<div style="flex:1;"><p style="margin:0;font-size:13px;font-weight:600;color:#1a1a1a;">Tote Bag incluida en tu pedido</p>'
              + '<p style="margin:3px 0 0;font-size:11px;color:#888;">' + r + '</p></div>';
          } else {
            html += '<div style="flex:1;"><p style="margin:0;font-size:13px;font-weight:600;color:#1a1a1a;">Tote Bag en tu pedido</p>'
              + '<p style="margin:3px 0 0;font-size:11px;color:#888;">$990</p></div>';
          }

        } else if (freeByTier) {
          /* Free by tier */
          var r = tier.isMuseFirst ? "Regalo de bienvenida al Círculo Ochi" : "Exclusivo para ti por ser Haute Couture";
          html += '<div style="flex:1;">'
            + '<p style="margin:0;font-size:13px;font-weight:600;color:#1a1a1a;">Tu Tote Bag va de regalo</p>'
            + '<p style="margin:3px 0 0;font-size:11px;color:#888;">' + r + '</p>'
            + '<button type="button" class="tote-upsell-add-free" style="margin-top:8px;padding:6px 16px;font-size:11px;font-weight:600;background:#1a1a1a;color:#fff;border:none;border-radius:4px;cursor:pointer;text-transform:uppercase;letter-spacing:0.04em;">Agregar gratis a mi pedido</button>'
            + '</div>';

        } else if (freeByAmount) {
          /* Free by cart amount */
          html += '<div style="flex:1;">'
            + '<p style="margin:0;font-size:13px;font-weight:600;color:#1a1a1a;">Tu Tote Bag va de regalo</p>'
            + '<p style="margin:3px 0 0;font-size:11px;color:#888;">Incluida en pedidos sobre $100.000</p>'
            + '<button type="button" class="tote-upsell-add-free" style="margin-top:8px;padding:6px 16px;font-size:11px;font-weight:600;background:#1a1a1a;color:#fff;border:none;border-radius:4px;cursor:pointer;text-transform:uppercase;letter-spacing:0.04em;">Agregar gratis</button>'
            + '</div>';

        } else if (tier.isGuest) {
          /* Guest — invite to create account */
          html += '<div style="flex:1;">'
            + '<p style="margin:0;font-size:13px;font-weight:600;color:#1a1a1a;">Tu Tote Bag de regalo</p>'
            + '<p style="margin:4px 0 0;font-size:11px;color:#a09e95;">'
            + '<a href=\"https://www.ochiandco.cl/customer_authentication/redirect?locale=es&region_country=CL\" style=\"color:#1a1a1a;text-decoration:underline;\">Crea tu cuenta</a> y agregala gratis a tu carrito</p>'
            + '</div>';

        } else if (totalExTote > 0) {
          /* Has items — show progress */
          html += '<div style="flex:1;">'
            + '<p style="margin:0;font-size:13px;font-weight:600;color:#1a1a1a;">Te faltan ' + formatCLP(remaining) + ' para tu Tote Bag gratis</p>'
            + '<div style="background:#f0ede8;border-radius:3px;height:4px;margin:8px 0;overflow:hidden;">'
            + '<div style="background:#1a1a1a;height:100%;width:' + pct + '%;border-radius:3px;transition:width 0.3s;"></div>'
            + '</div>'
            + '<label style="display:flex;align-items:center;gap:8px;cursor:pointer;margin:0;">'
            + '<input type="checkbox" class="tote-upsell-checkbox" style="min-width:16px;min-height:16px;accent-color:#1a1a1a;cursor:pointer;">'
            + '<span style="font-size:12px;color:#888;">O agregala ahora por <strong style="color:#1a1a1a;">$990</strong></span>'
            + '</label></div>';

        } else {
          /* Empty cart */
          html += '<label style="flex:1;display:flex;align-items:center;gap:10px;cursor:pointer;margin:0;">'
            + '<input type="checkbox" class="tote-upsell-checkbox" style="min-width:18px;min-height:18px;accent-color:#1a1a1a;cursor:pointer;">'
            + '<span><span style="display:block;font-size:13px;font-weight:600;color:#1a1a1a;">Agrega nuestra Tote Bag</span>'
            + '<span style="display:block;font-size:12px;color:#888;margin-top:2px;">Por solo <strong style="color:#1a1a1a;">$990</strong> · Gratis sobre $100.000</span>'
            + '</span></label>';
        }

        html += '</div>';
        buyBtns.insertAdjacentHTML("afterend", html);
      });
  }

  /* ── Auto-swap $990 → $0 for HC/MUSE ── */
  function autoSwapVariant() {
    var tier = getTierInfo();
    fetch("/cart.js").then(function(r){return r.json()}).then(function(cart) {
      var wrong = null;
      var totalExTote = cart.total_price;
      cart.items.forEach(function(item) {
        if (item.variant_id === TOTE_VARIANT) wrong = item;
        if (isToteVariant(item.variant_id)) totalExTote -= item.final_line_price;
      });
      var shouldBeFree = tier.isMuseFirst || tier.isHc || totalExTote >= FREE_THRESHOLD;
      if (!wrong || !shouldBeFree) return;
      fetch("/cart/change.js", {
        method: "POST", headers: {"Content-Type": "application/json"},
        body: JSON.stringify({id: wrong.key, quantity: 0})
      }).then(function() {
        return fetch("/cart/add.js", {
          method: "POST", headers: {"Content-Type": "application/json"},
          body: JSON.stringify({items: [{id: TOTE_FREE_VARIANT, quantity: 1}]})
        });
      }).then(function() { reloadCart(); });
    });
  }

  /* ── Cart page: highlight free tote if not added yet ── */
  function highlightFreeInCart() {
    if (window.location.pathname !== "/cart") return;
    document.querySelectorAll(".tote-upsell:not(.tote-upsell--product)").forEach(function(c) {
      if ((c.textContent || "").indexOf("GRATIS") !== -1 && c.dataset.toteInCart !== "true") {
        subtleHighlight(c);
      }
    });
  }

  /* ── Init ── */
  function init() { initProductUpsell(); autoSwapVariant(); highlightFreeInCart(); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();

// Auto-open Judge.me v1774453834 review form when ?write_review=true
(function(){
  if(window.location.search.indexOf('write_review=true')===-1)return;
  
  // Banner
  var b=document.createElement('div');
  b.id='review-banner';
  b.style.cssText='background:#202d19;color:white;padding:18px 20px;text-align:center;font-family:Montserrat,Arial,sans-serif;position:fixed;top:0;left:0;right:0;z-index:99999;box-shadow:0 4px 15px rgba(0,0,0,0.3);';
  b.innerHTML='<div style="max-width:500px;margin:0 auto;"><p style="font-size:16px;font-weight:600;letter-spacing:1px;margin:0 0 8px;">¿CÓMO TE FUE CON TU PIEZA?</p><p style="font-size:13px;font-weight:400;opacity:0.8;margin:0 0 12px;">Tu opinión ayuda a otras mujeres a elegir con confianza</p><button id="rev-go" style="background:#a09e95;color:white;border:none;padding:14px 32px;font-family:Montserrat,Arial,sans-serif;font-size:14px;font-weight:600;letter-spacing:1.5px;cursor:pointer;text-transform:uppercase;width:100%;max-width:320px;">ESCRIBIR MI RESEÑA ↓</button></div>';
  document.body.prepend(b);
  document.body.style.paddingTop='120px';
  
  document.getElementById('rev-go').onclick=function(){
    // Step 1: scroll to the Judge.me section (this ID always exists in the static HTML)
    var target=document.getElementById('judgeme_product_reviews');
    if(target){
      target.scrollIntoView({behavior:'smooth',block:'start'});
    }
    
    // Step 2: keep trying to find and click the write review button
    // Judge.me loads it dynamically so it might not exist yet
    var tries=0;
    var clickInterval=setInterval(function(){
      tries++;
      var writeBtn=document.querySelector('.jdgm-write-rev-link');
      if(writeBtn){
        writeBtn.style.display='inline-block';
        writeBtn.style.visibility='visible';
        writeBtn.click();
        clearInterval(clickInterval);
        // Hide banner
        b.style.display='none';
        document.body.style.paddingTop='0';
      }
      if(tries>30){
        // After 15 seconds, if button never appeared, scroll is enough
        // The client is already at the reviews section
        clearInterval(clickInterval);
        b.style.display='none';
        document.body.style.paddingTop='0';
      }
    },500);
  };
})();
